// extracted by mini-css-extract-plugin
export default {"CustomerSettings":"CustomerSettings_CustomerSettings__P-hPI"};